$(document).ready(function(){

    $('.biora_tab-block').click(function(){
        $(this).toggleClass('active');
        $(this).find('.biora_tab-content').slideToggle();
    });

    $('.biora_option').click(function(){
        $('.biora_option').removeClass('active');
        $(this).addClass('active');
    });

    $('.bopra_hairloss_nav-btn').click(function(){
        $('.bopra_hairloss_nav-btn').removeClass('active');
        $(this).addClass('active');
        var id = $(this).attr('data-id');
        $('.biora_hairloss-grid').addClass('hided');
        $('.biora_hairloss-grid[data-id="'+id+'"]').removeClass('hided');
    });

    $('.biorea_results-select-block').click(function(){
        $('.biorea_results-select-block').removeClass('active');
        $(this).addClass('active');

        var currentId = $(this).attr('data-id');
        $('.biora_result-container').addClass('hided');
        $('.biora_result-container[data-id="'+currentId+'"]').removeClass('hided');
    });

    $('.biora_read-more').click(function(){
        $(this).closest('.biora_ingredient-cell').find('.fullDescription').slideToggle();
    });

    $('.featured_biorea_results-select-block').click(function(){
        $(this).closest('.biora_section-outer').find('.featured_biorea_results-select-block').removeClass('active');
        $(this).addClass('active');
        var currentId = $(this).attr('data-id');

        $(this).closest('.biora_section-outer').find('.biora_products-grid').addClass('hided');
        $(this).closest('.biora_section-outer').find('.biora_products-grid[data-id="'+currentId+'"]').removeClass('hided');
    });
});


const thumbSwiper = new Swiper('.biora_gallery-carousel_thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
});

const mainSwiper = new Swiper('.biora_gallery-carousel', {
    spaceBetween: 0,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    thumbs: {
        swiper: thumbSwiper,
    },
});

 const ThumbSwiper = new Swiper('.biora_before-after-thumbnails', {
    spaceBetween: 24,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.thumb-next',
      prevEl: '.thumb-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 3,
      }
    }
  });

  const Beforeswiper = new Swiper('.biora_before-after-carousel', {
    loop: true,
    spaceBetween: 24,
    navigation: {
      nextEl: '.biora_before-after-carousel .swiper-button-next',
      prevEl: '.biora_before-after-carousel .swiper-button-prev',
    },
    thumbs: {
      swiper: ThumbSwiper,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      }
    }
  });

/* Sync seal subscriptions with custom selector */
document.addEventListener('DOMContentLoaded', () => {
  const BIO_OPTION_SEL = '.biora_option';
  const SEAL_ROOT_SEL = '.sealsubs-target-element .sealsubs-container';

  const PLAN_MONTHLY = '692057440602';
  const PLAN_3MONTHS = '692057473370';

  const sealRoot = document.querySelector(SEAL_ROOT_SEL);

  const getSealEls = () => {
    const root = document.querySelector(SEAL_ROOT_SEL) || sealRoot;
    if (!root) return null;

    return {
      root,
      oneTimeRadio: root.querySelector('input.sls-option[data-type="one_time"]'),
      subRadio: root.querySelector('input.sls-option[data-type="subscription"][data-selling-plan-group="0"], input.sls-option[data-type="subscription"]'),
      intervalSelect: root.querySelector('select[name="subs_interval"]'),
    };
  };

  const fireNative = (el, type) => {
    if (!el) return;
    el.dispatchEvent(new Event(type, { bubbles: true }));
    if (type === 'change') el.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const clickIfNeeded = (radio) => {
    if (!radio) return;
    if (!radio.checked) radio.click();
  };

  const setSubscription = (planId) => {
    const els = getSealEls();
    if (!els) return;

    clickIfNeeded(els.subRadio);

    if (els.intervalSelect) {
      els.intervalSelect.value = planId;
      if (els.intervalSelect.value !== planId) {
        const opt = [...els.intervalSelect.options].find(o => o.value === planId);
        if (opt) opt.selected = true;
      }
      fireNative(els.intervalSelect, 'change');
    }
  };

  const setOneTime = () => {
    const els = getSealEls();
    if (!els) return;
    clickIfNeeded(els.oneTimeRadio);
  };

  const syncSealToActiveBiora = () => {
    const active = document.querySelector(`${BIO_OPTION_SEL}.active`);
    if (!active) return;

    if (active.classList.contains('otp')) {
      setOneTime();
      return;
    }

    if (active.classList.contains('3-months')) {
      setSubscription(PLAN_3MONTHS);
      return;
    }

    if (active.classList.contains('1-month')) {
      setSubscription(PLAN_MONTHLY);
      return;
    }

    setSubscription(PLAN_MONTHLY);
  };

  syncSealToActiveBiora();

  document.querySelectorAll(BIO_OPTION_SEL).forEach(option => {
    option.addEventListener('click', () => {
      requestAnimationFrame(syncSealToActiveBiora);
    });
  });

  const optionsWrap = document.querySelector('.biora_options-container');
  if (optionsWrap) {
    const mo = new MutationObserver(() => {
      requestAnimationFrame(syncSealToActiveBiora);
    });
    optionsWrap.querySelectorAll(BIO_OPTION_SEL).forEach(el => {
      mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }
});